import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import omit from "lodash/omit";

const Button = props => (
  <button
    type={props.type}
    className={cx(
      "btn",
      {
        [`btn-${props.btnType}`]: props.btnType,
        [`btn-${props.btnSize}`]: props.btnSize,
        [`${props.className}`]: props.className,
      },
      {
        disabled: props.disabled,
      }
    )}
    style={{ width: props.btnWidth }}
    disabled={props.disabled}
    onClick={evt => !props.disabled && props.onClick(evt)}
    {...omit(props, ["type", "btnType", "btnWidth", "btnSize", "disabled", "className", "onClick"])}
  >
    {props.children}
  </button>
);

Button.defaultProps = {
  type: "button",
  btnType: "default",
  btnWidth: null,
  btnSize: "",
  disabled: false,
  className: null,
  onClick: () => {},
};

Button.propTypes = {
  type: PropTypes.oneOf(["button", "submit"]),
  btnType: PropTypes.oneOf(["default", "primary", "warning", "info", "link", "blue"]),
  btnSize: PropTypes.oneOf(["", "sm", "lg"]),
  disabled: PropTypes.bool,
  btnWidth: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]).isRequired,
  onClick: PropTypes.func,
};

export default Button;

require("./index.less");
require("./index.less");